<ng-container adHost></ng-container>
